
import {mapGetters} from 'vuex';

export default {
  name: 'schedule-filter-desktop',
  model: {
    prop: 'request',
    event: 'change',
  },
  props: {
    request: {
      type: Object,
      required: true,
    },
    white: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      timeClass: '',
      dateClass: '',
    };
  },
  computed: {
    ...mapGetters([
      'getPricesStatistic',
      'hasPrices',
    ]),
  },
  methods: {
    switchCalendarDropdown (value) {
      this.dateClass = value ? 'schedule-filter__date--opened' : '';
    },
    switchTimeDropdown (value) {
      this.timeClass = value ? 'schedule-filter__time--opened' : '';
    },
    getPrices() {
      const res = this.getPricesStatistic(this.request.from.code, this.request.to.code);
      return res;
    },
  },
};
